import * as React from 'react';
import ReactPannellum from 'react-pannellum';
import slideStyles from './Slide.styl';
const ROTATION_SPEED = 15;
const ROTATION_ANGLE = 10;
const TIMEOUT = 250;
export const SliderInterior = React.forwardRef(({ ratioW, ratioH, zoomLevel, minZoomLevel, maxZoomLevel, photo: { imageUrlLarge } }, ref) => {
    const timerRef = React.useRef(null);
    /* eslint-disable indent,@typescript-eslint/indent */
    React.useImperativeHandle(ref, () => {
        const startAutoRotate = (rotationSpeed) => {
            clearInterval(timerRef.current);
            timerRef.current = setTimeout(() => {
                ReactPannellum.getConfig().autoRotate = rotationSpeed;
                ReactPannellum.lookAt(ReactPannellum.getPitch(), ReactPannellum.getYaw(), ReactPannellum.getHfov());
            }, TIMEOUT);
        };
        const stop = () => {
            clearInterval(timerRef.current);
            if (ReactPannellum.getConfig().autoRotate) {
                ReactPannellum.stopAutoRotate();
            }
        };
        const rotate = (angle) => {
            if (!ReactPannellum.getConfig().autoRotate) {
                ReactPannellum.lookAt(ReactPannellum.getPitch(), ReactPannellum.getYaw() + angle, ReactPannellum.getHfov());
            }
            stop();
        };
        return {
            rotateLeftStart: () => startAutoRotate(ROTATION_SPEED),
            rotateRightStart: () => startAutoRotate(ROTATION_SPEED * -1),
            rotateLeftEnd: () => rotate(ROTATION_ANGLE * -1),
            rotateRightEnd: () => rotate(ROTATION_ANGLE),
            stopRotation: stop
        };
    }, []);
    React.useEffect(() => () => clearInterval(timerRef.current), []);
    React.useEffect(() => {
        const [minHfov, maxHfov] = ReactPannellum.getHfovBounds();
        ReactPannellum.setHfov(maxHfov - (maxHfov - minHfov) * (zoomLevel - minZoomLevel) / (maxZoomLevel - minZoomLevel));
    }, [zoomLevel]);
    /* eslint-enable indent,@typescript-eslint/indent */
    const paddingTop = `${100 * ratioH / ratioW}%`; // eslint-disable-line no-magic-numbers
    return (React.createElement("div", { style: { paddingTop }, className: slideStyles.imageClass },
        React.createElement(ReactPannellum, { id: 'id', sceneId: 'sceneId', imageSource: imageUrlLarge, config: {
                autoLoad: true,
                showControls: false,
                keyboardZoom: false,
                mouseZoom: false,
                doubleClickZoom: false,
                compass: false,
                maxHfov: 100
            }, style: {
                width: '100%',
                height: '100%',
                position: 'absolute',
                top: 0,
                left: 0
            } })));
});
